import { render, staticRenderFns } from "./InvoiceDraft.vue?vue&type=template&id=38adf81c&scoped=true"
import script from "./InvoiceDraft.vue?vue&type=script&lang=js"
export * from "./InvoiceDraft.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDraft.vue?vue&type=style&index=0&id=38adf81c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38adf81c",
  null
  
)

export default component.exports